module.exports = __webpack_public_path__ + "img/plus-circle-disabled.05f23b51.svg";